


import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import useSlider from "../../hooks/useSlider";
import AdminFooter from "../AdminFooter";
import Sidebar from "../sidebar/Sidebar";
import { getDashboardData, getUser } from "../../services/services";
import { Link } from "react-router-dom";
import { constant } from "../../utils/constants";
import moment from "moment";
import { Bar } from "react-chartjs-2";
import useDetails from "../../hooks/useDetails";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Dashboard = () => {
  const details = useDetails();
  const [role, setRole] = useState("monthly");
  const [page, setPage] = useState(constant.PAGE_ONE);
  const [search, setSearch] = useState("");
  const [limit] = useState(constant.PER_PAGE_TEN);
  const isSlider = useSlider();
  const [company, setCompany] = useState("{}");
  const comp = JSON?.parse(company);

  const { data: dashboardData, isLoading, error } = useQuery({
    queryKey: ["dashboard-data", role],
    queryFn: async () => {
      
      const resp = await getDashboardData(role,details?.companyUID);
      return resp;
    },
  });

  const { data: userData } = useQuery({
    queryKey: ["user-list", page, limit, comp?.id, role],
    queryFn: async () => {
      const resp = await getUser(page, limit, search,null,details?.userCompany?._id,null, role);
      return resp?.data?.data;
    },
  });

  let graphData = dashboardData?.data?.data?.revenueGraph || { labels: [], datasets: [] };  
  if (role === "monthly") {
    const weeks = ["Week 1", "Week 2", "Week 3", "Week 4"];
    const weeklyData = [0, 0, 0, 0];
    
    graphData.labels.forEach((day, index) => {
      const weekIndex = Math.floor(index / (graphData.labels.length / 4));
      weeklyData[weekIndex] += graphData.datasets[index] || 0;
    });
    
    graphData = { labels: weeks, datasets: weeklyData };
  }
  const chartData = {
    labels: graphData.labels,
    datasets: [
      {
        label: "Revenue",
        data: graphData.datasets,
        backgroundColor: "rgba(34, 139, 34, 0.7)", 
        borderRadius: 4,
        borderSkipped: false,
      },
    ],
  };
  

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      title: { display: true, text: `Total Dollar Spent (${role.charAt(0).toUpperCase() + role.slice(1)})` },
    },
    scales: {
      x: { ticks: { autoSkip: false, stepSize: 1 } },
      y: { beginAtZero: true },
    },
  };

console.log("companyUID", details?.companyUID);
console.log("details", details);

  return (
    <div className="mainbox">
      <Sidebar />
      <div className={isSlider ? "body-content close" : "body-content open"}>
        <Row>
          <Col xl={6}>
            <h2 className="mainhead font-24">Dashboard</h2>
          </Col>
          <Col xl={6}>
            <div className="d-flex justify-content-end align-items-center">
              <label className="labelText">Filter by:</label>
              <select
                className="form-select selectfeild"
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
              </select>
            </div>
          </Col>
        </Row>

        <div className="dash-widget">
          <Row>
            <Col xl={9}>
              <Row>
                {/* Total Users */}
                <Col xl={6} lg={6} md={6}>
                  <div className="widgetcard">
                    <div className="value">
                      <p>Total Users</p>
                      <h4>{dashboardData?.data?.data?.totalUsers || 0}</h4>
                    </div>
                    <div className="icon icon-two">
                      <img src="/images/curve.svg" alt="icon" className="img-fluid" />
                    </div>
                  </div>
                </Col>

                {/* Total Restaurants */}
                <Col xl={6} lg={6} md={6}>
                  <div className="widgetcard">
                    <div className="value">
                      <p>Total Locations</p>
                      <h4>{dashboardData?.data?.data?.locations || 0}</h4>
                    </div>
                    <div className="icon icon-one">
                      <img src="/images/curve.svg" alt="icon" className="img-fluid" />
                    </div>
                  </div>
                </Col>

                {/* Total Transactions */}
                <Col xl={6} lg={6} md={6}>
                  <div className="widgetcard">
                    <div className="value">
                      <p>Total Label Printed</p>
                      <h4>{dashboardData?.data?.data?.totalLabelPrinted || 0}</h4>
                    </div>
                    <div className="icon icon-three">
                      <img src="/images/curve.svg" alt="icon" className="img-fluid" />
                    </div>
                  </div>
                </Col>

                {/* Total Revenue */}
                <Col xl={6} lg={6} md={6}>
                  <div className="widgetcard">
                    <div className="value">
                      <p>Total Dollars Spent</p>
                      <h4>${dashboardData?.data?.data?.totalRevenue?.toFixed(2) || 0}</h4>
                    </div>
                    <div className="icon icon-four">
                      <img src="/images/curve.svg" alt="icon" className="img-fluid" />
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xl={3}>
              <div className="chart-container">
                <Bar options={chartOptions} data={chartData} />
              </div>
            </Col>
          </Row>
        </div>

        <div className="table-responsive tableOut">
          <table className="table tableDashboard">
            <thead className="thead-dark">
              <tr>
                <th>#</th>
                <th>User ID</th>
                <th>Name</th>
                <th>Email Address</th>
                <th>Role</th>
                <th>Added</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {userData?.users?.length > 0 ? (
                userData.users.map((item, index) => (
                  <tr key={index}>
                    <td>{(page - 1) * limit + (index + 1)}</td>
                    <td>{item?.userId}</td>
                    <td className="text-capitalize">{item?.userInfo?.name}</td>
                    <td>{item?.email}</td>
                    <td className="text-capitalize">{item?.role}</td>
                    <td>{moment(item?.createdAt).format("lll")}</td>
                    <td>
                      <Link to={`../userdetail/${item?._id}`}>
                        <img src="/images/eye.svg" className="img-fluid actionIcon" alt="view" />
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="text-center">
                    <h4>No Users Found</h4>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <AdminFooter />
    </div>
  );
};

export default Dashboard;
